import {
    PlaceClient
} from "@/services/PlaceClient.ts"

import {
    instance
} from "@/services/axios.base.js"


/* global serverAddress */
export const clients = {
     placeServiceClient : new PlaceClient(process.env.VUE_APP_BACKEND_ENDPOINT,instance)
}

